import * as React from "react";
import { Link , useNavigate} from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import { Button, TableContainer } from "@mui/material";
import SettingModal from "./modals/settingModal";
import { setAuthToken } from "../../utils/setAuthToken";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Generate Order Data
// function createData(appname, token) {
//   return {appname, token };
// }

// const rows = [createData(0, "Order 11"), createData(0, "Order 11")];

export default function ApiTable() {
  // Modal use State
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //Normal use states
  const [rows, setRows] = React.useState([]);
  const navigate=useNavigate();
  const getRows = (e) => {
    setAuthToken(localStorage.getItem("jwtToken"));
    axios
      .get("https://api.blockpay.co.za/merchant/getApiKeys", {})
      .then((res) => {
        console.log(res);
        toast.success(res.data.message);
        setRows([{ name: res.data.name, token: "**********", delete: true }]);
        console.log(rows);
      })
      .catch((err) => {
        
        console.log(err);
        if (err.response.data.message == "Unauthorized!") {
          axios
            .post("https://api.blockpay.co.za/auth/refreshToken", {
              refreshToken: localStorage.getItem("refreshToken"),
            })
            .then((res) => {
              console.log(res);
              localStorage.setItem("jwtToken", res.data.accessToken);
              setTimeout(() => {
                window.location.reload();
              }, 500);
            })
            .catch((err) => {
              console.log(err);
              localStorage.clear();
              window.location.reload();
            });
        }
      });
  };
  const deleteAPIKey = (e) => {
    setAuthToken(localStorage.getItem("jwtToken"));
    axios
      .post("https://api.blockpay.co.za/merchant/deleteApiKey", {})
      .then((res) => {
        toast.success(res.data.message);
        console.log(res);
        window.location.reload();
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log(err);
        if (err.response.data.message == "Unauthorized!") {
          axios
            .post("https://api.blockpay.co.za/auth/refreshToken", {
              refreshToken: localStorage.getItem("refreshToken"),
            })
            .then((res) => {
              console.log(res);
              localStorage.setItem("jwtToken", res.data.accessToken);
              setTimeout(() => {
                window.location.reload();
              }, 500);
            })
            .catch((err) => {
              console.log(err);
              localStorage.clear();
              window.location.reload();
            });
        }
        
      });
  };
  React.useEffect(() => {
    getRows();
  }, []);
  return (
    <React.Fragment>
      <ToastContainer/>
      <Box sx={{ textAlign: "left", borderRadius: "6px" }}>
        <div
          sx={{ marginBottom: "16px", display: "flex", alignItems: "flex-end" }}
        >
          <Typography
            sx={{
              float: "left",
              fontSize: "1.1rem",
              lineHeight: "27px",
              fontWeight: 600,
              color: "black!important",
            }}
          >
            API Keys
          </Typography>
          <Typography
            sx={{
              float: "right",
              fontSize: "1rem",
              lineHeight: "25.6px",
              fontWeight: 600,
              color: "#05B2FF",
              textDecoration: "none",
            }}
            component={Button}
            onClick={handleOpen}
            // to="/transaction"
          >
            + ADD
          </Typography>
          <SettingModal open={open} onClose={handleClose} />
        </div>
      </Box>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table size="medium">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  color: "#666666",
                  fontWeight: 400,
                  fontSize: "1rem",
                  lineHeight: "27.2px",
                }}
              >
                App Name
              </TableCell>
              <TableCell
                sx={{
                  color: "#666666",
                  fontWeight: 400,
                  fontSize: "1rem",
                  lineHeight: "27.2px",
                }}
              >
                API Key Token
              </TableCell>
              <TableCell
                sx={{
                  color: "#666666",
                  fontWeight: 400,
                  fontSize: "1rem",
                  lineHeight: "27.2px",
                }}
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow sx={{ padding: "22px 14px" }} key={rows}>
                <TableCell
                  style={{
                    borderBottom: "none",
                    color: "#111111",
                    fontWeight: 500,
                    fontSize: "1rem",
                    lineHeight: "20px",
                  }}
                >
                  {row.name}
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "none",
                    color: "#111111",
                    fontWeight: 500,
                    fontSize: "1rem",
                    lineHeight: "20px",
                  }}
                >
                  {row.token}
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "none",
                    color: "#111111",
                    fontWeight: 500,
                    fontSize: "1rem",
                    lineHeight: "2px",
                    textAlign: "right",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {
                    <Box component={Link} onClick={deleteAPIKey}>
                      <DeleteOutlineIcon sx={{ color: "red" }} />
                    </Box>
                  }
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
}
